import * as Sentry from '@sentry/vue';
import {ErrorReporter} from './error-reporter';
import {CustomError} from '@/errors/types/CustomError';
import Vue from 'vue';

export class SentryReporter implements ErrorReporter {
  constructor(dsn: string, environment: string, release: string) {
    // Init sentry for basic error reporting, but no tracing or profiling.
    Sentry.init({
      Vue,
      dsn,
      tracesSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      replaysSessionSampleRate: 0,
      profilesSampleRate: 0,
      environment: environment ?? 'local',
      release: release ?? 'LATEST',
      beforeSend: (event, hint) => {
        // TODO: Add logic to filter out error if consent cookie not set.
        return event;
      },
    });
  }

  async reportError(err: CustomError): Promise<void> {
    Sentry.captureException(err);
  }

  async reportErrors(errors: CustomError[]): Promise<void[]> {
    return Promise.all(errors.map((err: Error) => this.reportError(err)));
  }
}

export default SentryReporter;
